import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const transactionService = {
     async getAllAsync(params) {
    const response = await apiClient.get(endPoints.transaction.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.transaction.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
}